export default __webpack_public_path__ + "static/nav-open-019cf64707fb2d5379b395952e36fc9a.mp3";